export const captchaValidator = (token: string) =>
  !token ? 'Please complete the captcha' : null;
